import React, { useState } from 'react'
import Image from 'next/image'

import { defaultLoader } from '../utils/custom-image-loader'

const GeneralImageHero = ({ image, dynamicMediaUrl = null, dynamicMediaMobileUrl = null, alt = 'General hero image', mobileImage, marginTop = true }) => {
  const [error, setError] = useState(false)
  const dynamicMediaImg = dynamicMediaUrl || image
  const dynamicMediaMobileImg = dynamicMediaMobileUrl || mobileImage

  return (
    <div
      data-testid = 'general-image-hero-wrapper'
      className={`general-image-hero__wrapper${marginTop ? ' general-image-hero__wrapper-margin' : ''}`}
      style={{ display: error ? 'none' : 'block' }}
    >
      {dynamicMediaMobileImg && (
        <div className="general-image-hero general-image-hero--mobile image-next">
          <Image
            src={dynamicMediaMobileImg}
            onError={() => setError(true)}
            alt={alt}
            fill
            loader={defaultLoader}
          />
        </div>
      )}
      {dynamicMediaImg && (
        <div className="general-image-hero general-image-hero--desktop image-next">
          <Image
            src={dynamicMediaImg}
            onError={() => setError(true)}
            alt={alt}
            fill
            loader={defaultLoader}
          />
        </div>
      )}
    </div>
  )
}

export default GeneralImageHero
